var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3179 7.99994L15.727 1.59085C16.091 1.22736 16.091 0.636924 15.727 0.272968C15.3631 -0.0909892 14.7726 -0.0909892 14.4091 0.272968L8 6.68205L1.59087 0.272968C1.22737 -0.0909892 0.636463 -0.0909892 0.27297 0.272968C-0.0909899 0.636924 -0.0909899 1.22736 0.27297 1.59085L6.6821 7.99994L0.27297 14.409C-0.0909899 14.7725 -0.0909899 15.363 0.27297 15.7269C0.454716 15.9087 0.693317 16 0.931918 16C1.17052 16 1.40912 15.9087 1.59087 15.7269L8 9.31783L14.4091 15.7269C14.5909 15.9087 14.8295 16 15.0681 16C15.3062 16 15.5453 15.9087 15.727 15.7269C16.091 15.363 16.091 14.7725 15.727 14.409L9.3179 7.99994Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.371d78c88e3d06c9fb7151159cb42725.svg";
export { ForwardRef as ReactComponent };